import React from 'react';
import '../styles/PlanOptions.css';

function PlanOptions({ sectionTitle, sectionDescription, options }) {
  return (
	<div className="three-options">
	  {/* Section Title */}
	  <h2 className="three-options-header">{sectionTitle}</h2>
	  
	  {/* Section Description */}
	  <p className="three-options-description">{sectionDescription}</p>
	  
	  {/* Options Grid */}
	  <div className="three-options-grid">
		{options.map((option, index) => (
		  <div key={index} className="three-options-card">
			<h3 className="option-number">{`0${index + 1}`}</h3>
			<h4 className="option-title">{option.title}</h4>
			<p className="option-body">{option.body}</p>
		  </div>
		))}
	  </div>
	</div>
  );
}

export default PlanOptions;